import { h, FunctionalComponent } from "preact";
import CloseIcon from "../../icons/CloseIcon";
import LongArrowIcon from "../../icons/LongArrowIcon";
import { formatCurrencyValue } from "../../services/helpers";
import MvArea from "../../models/MvArea";
import Button from "../Button/Button";
import { Text } from "preact-i18n";

import styles from "./style.module.scss";
import { getAddressCount } from "services/selectionHelpers";
import { SDKState } from "services/sdkState";

export interface SummaryProps {
    state: SDKState;
    onClose?(): void;
    onAreaRemove?(area: MvArea): void;
}

const Summary: FunctionalComponent<SummaryProps> = ({
    state,
    onClose,
    onAreaRemove,
}: SummaryProps) => {
    const { selection, pricePerAddress, totalSelected } = state;

    return (
        <div className={styles.mvSummary}>
            <div className={styles.mvSummaryHeader}>
                <h2 className={styles.mvSummaryTitle}>
                    <Text id="summary.header.title">Summary</Text>
                </h2>
            </div>
            <div className={styles.mvSummaryBody}>
                {selection
                    .filter((a) => a.result)
                    .map((a: MvArea) => {
                        const areaCount = getAddressCount(a.selectedAddresses);
                        return (
                            <div className={styles.mvSummaryArea} key={a.id}>
                                <div className={styles.mvSummaryAreaMain}>
                                    <h3>
                                        {a.result?.straatnaam}{" "}
                                        {a.result?.huisnr}
                                        {a.result?.huisnr_bag_letter
                                            ? `${a.result?.huisnr_bag_letter}${
                                                  a.result
                                                      ?.huisnr_bag_toevoeging ||
                                                  ""
                                              }`
                                            : ""}
                                        , {a.result?.postcode}{" "}
                                        {a.result?.plaatsnaam}
                                    </h3>
                                    <span>
                                        {areaCount}{" "}
                                        <Text
                                            id="general.labels.addresses"
                                            plural={areaCount}
                                        >{`adress${
                                            areaCount === 1 ? "" : "ses"
                                        }`}</Text>
                                    </span>
                                </div>
                                <span>
                                    {formatCurrencyValue(
                                        areaCount * pricePerAddress,
                                    )}
                                </span>
                                <button
                                    onClick={() => {
                                        if (!onAreaRemove) {
                                            return;
                                        }
                                        onAreaRemove(a);
                                    }}
                                    disabled={a.disabled}
                                    className={styles.mvSummaryAreaRemoveButton}
                                >
                                    <CloseIcon
                                        className={
                                            styles.mvSummaryRemoveAreaIcon
                                        }
                                    />
                                </button>
                            </div>
                        );
                    })}
                <div className={styles.mvSummaryTotal}>
                    <div className={styles.mvSummaryAreaMain}>
                        <span>
                            <Text id="general.labels.total">Total</Text>:{" "}
                            {totalSelected}{" "}
                            <Text
                                id="general.buttons.addressesSelected"
                                plural={totalSelected}
                            >
                                {`adress${totalSelected === 1 ? "" : "ses"}
                             selected`}
                            </Text>
                        </span>
                    </div>
                    <span>
                        {formatCurrencyValue(totalSelected * pricePerAddress)}
                    </span>
                </div>
            </div>

            <div className={styles.mvSummaryFooter}>
                <Button type="secondary" onClick={onClose}>
                    <LongArrowIcon
                        fill="currentColor"
                        className={styles.mvSummaryBackIcon}
                    />
                    <Text id="general.buttons.back">Back</Text>
                </Button>
            </div>
        </div>
    );
};

export default Summary;
